/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Workout_After_Next_SessionInputs */

const en_us2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Next workout: ${i?.label}`)
};

const pt_br2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo treino: ${i?.label}`)
};

const es_419_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo entrenamiento: ${i?.label}`)
};

const pt_pt2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Próximo treino: ${i?.label}`)
};

const fr_fr2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prochaine séance : ${i?.label}`)
};

const de_de2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Nächstes Training: ${i?.label}`)
};

const it_it2_workout_after_next_session = /** @type {(inputs: Workout_After_Next_SessionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Prossimo allenamento: ${i?.label}`)
};

/**
* | output |
* | --- |
* | "Next workout: {label}" |
*
* @param {Workout_After_Next_SessionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_next_session = /** @type {((inputs: Workout_After_Next_SessionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Next_SessionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_next_session(inputs)
	if (locale === "es-419") return es_419_workout_after_next_session(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_next_session(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_next_session(inputs)
	if (locale === "de-DE") return de_de2_workout_after_next_session(inputs)
	if (locale === "it-IT") return it_it2_workout_after_next_session(inputs)
	return en_us2_workout_after_next_session(inputs)
});
export { workout_after_next_session as "workout-after.next_session" }